import { api } from "@/api";
import {
  ClearSportSuspensionsParams,
  ClearSportSuspensionsResponse,
} from "@/types/ApiResponses/Sport";

export const clearSportsSuspensions = async (
  params: ClearSportSuspensionsParams
): Promise<ClearSportSuspensionsResponse> => {
  const res = await api.client.delete(`/sports-new/suspensions`, {
    params,
  });
  return res.data;
};
